<template>
  <div class="invoice-table-header">
    <div class="table__header__title">{{ title }}</div>
    <div class="d-flex align-items-center px-2">
      <img @click="goToPrint()" src="../../../assets/images/printer.svg" style="cursor: pointer" :style="printIconColor" />
      <button @click="toggleFormalInvoice" :class="isFormal ? 'formalInvoice' : 'informalInvoice'" class="d-flex align-items-center justify-content-between p-2 ms-3">
        <div class="d-flex align-items-center btnTitle">
          <img v-if="isFormal" src="../../../assets/images/invoice.svg" class="me-1" />
          <img v-else src="../../../assets/images/gray-invoice.svg" class="me-1" />
          <div>
            <span v-if="isFormal">فاکتور رسمی</span>
            <span v-else> فاکتور غیررسمی</span>
          </div>
        </div>
        <img v-if="isFormal" src="../../../assets/images/white-check.svg" />
        <img v-else src="../../../assets/images/gray-close.svg" />
      </button>
    </div>
  </div>
</template>

<script>
import { invoiceMixins } from '../../../utils/mixins'
export default {
  name: 'invoice-table-header',
  mixins: [invoiceMixins],
  props: {
    title: {
      type: String,
      default: '',
    },
    showPrinter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formalInvoice: true,
      printIconColor: 'filter: invert(65%) sepia(0%) saturate(19%) hue-rotate(183deg) brightness(96%) contrast(83%);'
    }
  },
  computed: {
    route() {
      return this.$route
    },
    printIconStyle(){
      return ''
    }
  },
  methods: {
    toggleFormalInvoice() {
      if(!this.route.params.id){
         if (this.isFormal) {
          
          
          const changedItems = this.invoiceList
          for (let i = 0; i < changedItems.length; i++) {
            changedItems[i].items.find(el => el.fieldName === "TotalPriceAfterDiscountAndTax").value -= changedItems[i].items.find(el => el.fieldName === 'TotalTaxCost').value
            changedItems[i].items.find(el => el.fieldName === 'TotalTaxCost').value = 0
          }
          this.setUpdatedInvoiceList(changedItems)
          this.$emit('listUpdated', true)
        } else {
          
          
          const changedItems = this.invoiceList
          for (let i = 0; i < changedItems.length; i++) {
            changedItems[i].items.find(el => el.fieldName === 'TotalTaxCost').value = changedItems[i].items.find(el => el.fieldName === 'ProductsTotalPrice').value * 0.09
            changedItems[i].items.find(el => el.fieldName === "TotalPriceAfterDiscountAndTax").value += changedItems[i].items.find(el => el.fieldName === 'TotalTaxCost').value
          }
        }
        const bool = !this.isFormal
        this.setIsFormal(bool)
      }
    },
    goToPrint() {
      if (this.invoiceList.length >= 1 && this.$route.params.id) {
        this.$router.push({ path: `/printInvoice/print/${this.route.params.id}` })
      } else {
        return
      }
    },
  },
  watch:{
    invoiceList(list){
      if(list.length > 0 && this.$route.params.id){
        this.printIconColor = ''
      } else if (list.length == 0) {
        this.printIconColor = 'filter: invert(65%) sepia(0%) saturate(19%) hue-rotate(183deg) brightness(96%) contrast(83%);'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.invoice-table-header {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.table__header__title {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0px;
  color: #444444;
}
button {
  border-radius: 5px;
  width: 147px;
  height: 38px;
}
.formalInvoice {
  background-color: #556ee6;
  color: #ffffff;
}

.informalInvoice {
  color: #999999;
  background-color: #ffffff;
  border: 1px solid #ced4da;
  border-radius: 4px;
}

.btnTitle {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 0px;
}
</style>
